import {
  TransactionCategoryLiteModel,
  useGetTransactionCategories,
} from 'api-hooks/transaction-category';
import { NavigationRoutes } from 'common/constants';
import { IColumn } from 'components/elements/table-component/table-component';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function TransactionCategoryList() {
  const { t } = useTranslation();
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);

  const columns = React.useMemo<IColumn<TransactionCategoryLiteModel>[]>(
    () => [
      {
        header: t('common:name'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
    ],
    [t],
  );

  const permission = useGetCrudPermission('transaction-categories');

  return (
    <UniskaiListTemplate
      title={t(`pathname:${NavigationRoutes.TransactionCategoriesList}`)}
      addNavigation={NavigationRoutes.TransactionCategoriesCreate}
      showAdd={permission.create}
      columns={columns}
      useQuery={useGetTransactionCategories}
      page={page}
      setPage={setPage}
      tableName={NavigationRoutes.TransactionCategoriesList}
      queryInput={{
        params: {
          page,
        },
      }}
      rowLink={
        permission.view
          ? (row) => ({
              pathname: NavigationRoutes.TransactionCategoriesView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
